export default "__VITE_ASSET__CurlslTW__"